// Shared topic helpers used by the sidebar and the home gallery.

// A small, friendly icon for each topic (keyword based, with a sane fallback).
export function topicEmoji(name) {
  const n = (name || "").toLowerCase();
  const map = [
    ["matrix", "🔲"], ["array", "🔢"], ["string", "🔤"], ["link", "🔗"],
    ["sort", "🗂️"], ["search", "🔍"], ["binary tree", "🌳"], ["bst", "🌲"],
    ["tree", "🌳"], ["greedy", "💰"], ["backtrack", "↩️"], ["stack", "📚"],
    ["queue", "📚"], ["heap", "⛰️"], ["graph", "🕸️"], ["trie", "🌴"],
    ["dynamic", "⚡"], ["dp", "⚡"], ["bit", "🧮"], ["math", "➗"],
    ["hash", "#️⃣"], ["window", "🪟"], ["pointer", "👉"], ["recursion", "🌀"],
  ];
  for (const [k, e] of map) if (n.includes(k)) return e;
  return "📄";
}
